























import dayJs from 'dayjs';
import { pageFactory } from '@/main/pages/pageFactory';
import { pageStoreBuilder } from '@/main/store/pages/page/builder';

import { apiProvider } from './pages/api';

const DATETIME_FORMAT = 'yyyy/MM/dd HH:mm:ss';
const VUE_BUILD_DATETIME = parseInt(process.env.VUE_APP_BUILD_DATETIME ?? '', 10);

const name = 'OAplikaci';

const store = pageStoreBuilder({
	name,
	crumbLabel: 'ADM_Aplikace',
	dropdownList: {},
	localState: {
		apiBuildDateTime: null as string | null,
		apiDbVersion: null as string | null,
	},
	props: {
		mode: null,
	},
});

export default pageFactory(name, store).extend({
	computed: {
		localizeBuildDate(): string {
			return this.LocalizePopisostatni('AppBuildDate');
		},
		localizeAppVersion(): string {
			return this.LocalizePopisostatni('AppVersion');
		},
		localizeApiDbVersion(): string {
			return this.LocalizePopisostatni('ApiDbVersion');
		},
		vueBuildDateTime: () => dayJs(VUE_BUILD_DATETIME, 'x').format(DATETIME_FORMAT),
		dmsVersion: () => process.env.VUE_APP_VERSION,
	},

	async created() {
		const { data } = await apiProvider.getAboutAplicationData();

		this.apiBuildDateTime = dayJs(data.CreateDate).format(DATETIME_FORMAT);
		this.apiDbVersion = data.DbVersion;
	},
});
